import { useEffect, useRef, useState } from 'react';

function useCopyToClipboard(): { copy: (text: string) => void; copied: boolean; error: boolean } {
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  // Clear any pending timer when the component using this hook unmounts.
  useEffect(
    () => () => {
      if (timeoutRef.current !== null) {
        clearTimeout(timeoutRef.current);
      }
    },
    [],
  );

  const copy = (text: string) => {
    if (timeoutRef.current !== null) {
      clearTimeout(timeoutRef.current);
    }
    setCopied(false);
    setError(false);

    if (typeof navigator === 'undefined' || !navigator.clipboard?.writeText) {
      setError(true);
      timeoutRef.current = setTimeout(() => setError(false), 2000);
      return;
    }

    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopied(true);
        timeoutRef.current = setTimeout(() => setCopied(false), 2000);
      })
      .catch(() => {
        setError(true);
        timeoutRef.current = setTimeout(() => setError(false), 2000);
      });
  };

  return { copy, copied, error };
}

export default useCopyToClipboard;
